define(function () {

    "use strict";

    return {
        missingContainer : "missing_container",
        missingModel : "missing_model",

        getMDSDError : "impossible to load mdsd"
    };
});
